export default {"src":"/login-app/[GIT_HASH]/_next/static/media/subtract.65cbbf89.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};